import React, { useState } from "react";
import { Modal, Button, Form, Spinner } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import {ENTITY_LABELS} from "../../utils/labelMapping"
import classes from "./FormModal.module.css";

function ProductCategoryFormModal({
  show,
  handleClose,
  handleAddProductCategory,
  customerBrandProducts,
}) {
  const brandProducts = useSelector((state) => state.brandProducts);
  const [productCategoryName, setproductCategoryName] = useState("");
  const [productCategoryDescription, setproductCategoryDescription] =
    useState("");
  const [selectedBrandProduct, setSelectedBrandProduct] = useState("");

  const handleAddProductCategoryInfo = () => {
    const brandProductId = customerBrandProducts.filter(
      (brand) => brand?.brand_product?.name === selectedBrandProduct
    )[0]?.id;
    const payload = {
      category_name: productCategoryName,
      category_description: productCategoryDescription,
      customer_brand_product_id: brandProductId,
    };

    // handleAddProductCategory(payload);
  };

  return (
    <Modal
      style={{ border: "none", borderRadius: "0px" }}
      show={show}
      onHide={handleClose}
    >
      <Modal.Header closeButton>
        <Modal.Title style={{ color: "grey", fontSize: "20px" }}>
          Add product category
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Control
          style={{ padding: "12px 12px", width: "70%", margin: "auto" }}
          as="textarea"
          rows={1}
          cols={2}
          name="firstName"
          placeholder="Category Name"
          // className="big"
          value={productCategoryName}
          onChange={(e) => setproductCategoryName(e.target.value)}
        />
        <p> </p>
        <Form.Control
          style={{ padding: "12px 12px", width: "70%", margin: "auto" }}
          as="textarea"
          rows={2}
          cols={2}
          name="firstName"
          placeholder="Details for disambigution"
          // className="big"
          value={productCategoryDescription}
          onChange={(e) => setproductCategoryDescription(e.target.value)}
        />
        <p> </p>

        <p> </p>
        <Form.Group>
          <Form.Control
            as="select"
            value={selectedBrandProduct}
            onChange={(e) => {
              setSelectedBrandProduct(e.target.value);
            }}
            style={{ height: "50px", width: "330px", margin: "auto" }}
          >
            <option value="">select {ENTITY_LABELS.brand}-{ENTITY_LABELS.product} </option>
            {customerBrandProducts &&
              customerBrandProducts.length !== 0 &&
              customerBrandProducts.map((brand) => (
                <option value={brand?.brand_product?.name}>
                  {brand?.brand_product?.name}
                </option>
              ))}
          </Form.Control>
        </Form.Group>

        <br />
      </Modal.Body>
      <Modal.Footer
        style={{ justifyContent: "center" }}
        className={classes.actions}
      >
        <Button
          disabled={brandProducts?.loading}
          style={{ backgroundColor: "green", width: "30%" }}
          variant="success"
          onClick={() => handleAddProductCategoryInfo()}
        >
          {brandProducts?.loading ? (
            <div style={{ fontSize: "14px" }}>
              <Spinner
                as="span"
                animation="grow"
                size="sm"
                role="status"
                aria-hidden="true"
              />
              Please Wait...
            </div>
          ) : (
            <div>Add</div>
          )}
        </Button>
        <Button
          style={{ backgroundColor: "#d32f2f", width: "30%" }}
          variant="danger"
          onClick={handleClose}
        >
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default ProductCategoryFormModal;
